import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGiftCardsinline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 26,
	height: 24,
	viewBox: "0 0 26 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 18,
				x: 1,
				y: 3,
				stroke: "#000",
				strokeWidth: 2,
				rx: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#000",
				strokeWidth: 2,
				d: "M11,16 L7.9954834,13",
				transform: "matrix(-1 0 0 1 18.995 0)"
			}),
			/* @__PURE__ */ _jsx("polygon", {
				stroke: "#000",
				strokeWidth: 2,
				points: "6 8 11 7 11 13.004 6 12.004",
				transform: "matrix(-1 0 0 1 17 0)"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#000",
				strokeWidth: 2,
				d: "M14,16 C14,16 12.9984945,15 10.9954834,13"
			}),
			/* @__PURE__ */ _jsx("polygon", {
				stroke: "#000",
				strokeWidth: 2,
				points: "11 8 16 7 16 13.004 11 12.004"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#000",
				strokeWidth: 2,
				d: "M2 10L5 10M17 10L24 10",
				transform: "matrix(1 0 0 -1 0 20)"
			})
		]
	})
});
export default SvgGiftCardsinline;
